const VALIDATION_ERRORS = {
  INVALID_COUNTRY_CODE: "INVALID_COUNTRY_CODE",
  COUNTRY_CODE_NOT_ALLOWED: "COUNTRY_CODE_NOT_ALLOWED",
  INVALID_PHONE_NUMBER: "INVALID_PHONE_NUMBER",
  DUPLICATE_CONTACT: "DUPLICATE_CONTACT",
  OPT_OUT_NUMBER: "OPT_OUT_NUMBER",
  COUNTRY_CODE_NOT_ALLOWED : "COUNTRY_CODE_NOT_ALLOWED"
};

const VALIDATION_WARNINGS = {
  WARNING_INVALID_FIRST_NAME_FORMAT: "WARNING_INVALID_FIRST_NAME_FORMAT",
  WARNING_INVALID_LAST_NAME_FORMAT: "WARNING_INVALID_LAST_NAME_FORMAT"
};

module.exports = {VALIDATION_WARNINGS, VALIDATION_ERRORS}